import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

import { ApplicationState } from 'src/store'
import { getClosings } from 'src/core/store/ducks/closings/actions'
import currencyMask from 'src/components/Formik/InputCurrency/mask'
import history from 'src/config/routes/history'
import useDocumentTitle from 'src/hooks/use-document-title'

import * as CSS from '../styles'
import Header from '../components/Header'
import StatusFilter from '../../components/StatusFilter'
import Table, { DataSource } from '../../components/Table'

export default function Closings() {
  useDocumentTitle('web.side.closings')
  const { closings } = useSelector((state: ApplicationState) => ({
    closings: state.closings
  }))
  const dispatch = useDispatch()

  const [list, setList] = useState<DataSource[]>([])
  const [currentPage, setCurrentPage] = useState<number>(1)

  useEffect(() => {
    dispatch(getClosings({ filterStatus: closings.filterStatus, page: 1 }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setList(
      closings.list.map(
        ({
          controllers,
          cost,
          request_id,
          request_number,
          request_closings,
          requested_on,
          status,
          sync_status,
          title
        }) => ({
          controllers,
          cost: currencyMask({ formatStr: true, value: cost }).maskedValue,
          extra: { request_closing_id: request_closings[0].request_closing_id },
          id: request_id,
          key: request_id,
          number: request_number,
          startDate: moment.unix(requested_on).format('DD/MM/YYYY'),
          status,
          sync_status,
          title,
          users: request_closings.map(({ request_user_data, status }) => ({
            gender: request_user_data.traveler.gender,
            name: request_user_data.traveler.name,
            reason: request_user_data.reason,
            status,
            user_id: request_user_data.traveler.user_id
          }))
        })
      )
    )
  }, [closings.list])

  return (
    <>
      <Header error={closings.error} title="web.side.closings" />
      <CSS.HeaderFilters>
        <StatusFilter
          defaultValue={closings.filterStatus}
          onChange={values => {
            dispatch(getClosings({ filterStatus: values, page: 1 }))
            setCurrentPage(1)
          }}
          options={['pending', 'approved', 'canceled', 'reproved', 'expired']}
        />
      </CSS.HeaderFilters>
      <Table
        closings
        currentPage={currentPage}
        dataSource={list}
        loading={closings.loading}
        onChange={page => {
          dispatch(getClosings({ filterStatus: closings.filterStatus, page }))
          setCurrentPage(page)
        }}
        onRow={(record: DataSource) => ({
          onClick: () =>
            history.push(
              `/closings/${record.extra.request_closing_id}/request/${record.id}`
            )
        })}
        totalPages={closings.total_results}
      />
    </>
  )
}
